module.exports = __webpack_public_path__ + "static/media/warning-icon.c1d407c4.svg";